var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.793,
    height: 16.793,
    viewBox: "0 0 16.793 16.793",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3033",
    "data-name": "Group 3033",
    transform: "translate(-409 -632.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_4508",
    "data-name": "Path 4508",
    transform: "translate(409 632.19)",
    fill: "#191919"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16.29296493530273 16.29296493530273 L 0.5000043511390686 16.29296493530273 L 0.5000043511390686 0.5000043511390686 L 4.89795446395874 0.5000043511390686 L 16.29296493530273 0.5000043511390686 L 16.29296493530273 16.29296493530273 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.000004768371582 1.000004768371582 L 1.000004768371582 15.79296398162842 L 15.79296398162842 15.79296398162842 L 15.79296398162842 1.000004768371582 L 1.000004768371582 1.000004768371582 M 3.814697265625e-06 3.814697265625e-06 L 16.79296493530273 3.814697265625e-06 L 16.79296493530273 16.79296493530273 L 3.814697265625e-06 16.79296493530273 L 3.814697265625e-06 3.814697265625e-06 Z",
    stroke: "none",
    fill: "#2a32ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4509",
    "data-name": "Path 4509",
    d: "M121.552,156.2l-.337.4-5.606,6.595-3.014-3.546a.263.263,0,0,0-.414.008.39.39,0,0,0,0,.479l3.221,3.789a.263.263,0,0,0,.414,0l6.15-7.234a.389.389,0,0,0-.007-.487A.262.262,0,0,0,121.552,156.2Z",
    transform: "translate(300.531 480.842)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.d31d461c35141a6d302d67b6d715b67e.svg";
export { ForwardRef as ReactComponent };